// const entities = store => {
//   console.log('entities', store)
//   // store.dispatch('topics/assignSpeakers', store.getters['speakers/byID'])
// }

// export default entities

export default function entitiesPlugin (modelsMap) {

  function updated(payload) {
    for(var key in modelsMap) {
      const data = payload[key]
      const model = modelsMap[key]
      if(model && data) {
        model.insertOrUpdate({ data })
      }
    }
  }

  function deleted(payload) {
    for(var key in modelsMap) {
      const id = payload[key]
      const model = modelsMap[key]
      if(model && id) {
        model.delete(id)
      }
    }
  }

  if(window.Echo) {
    window.Echo.private('entities')
               .listen('EntityUpdated', updated)
               .listen('EntityDeleted', deleted)
  }

  return store => {
    store.subscribe(mutation => {
      if(mutation.payload && mutation.payload.entities) {
        for(var key in mutation.payload.entities) {
          const model = modelsMap[key]
          const items = mutation.payload.entities[key]
          if(model) model.insertOrUpdate(items)
        }
      }
      else {
        const parts = mutation.type.split('/')
        if(parts.length == 3 && parts[0] == 'entities' && (['DATA', 'ITEM'].indexOf(parts[2]) >= 0)) {
          const model = modelsMap[parts[1]]
          if(model) model.insertOrUpdate({ data: mutation.payload })
        }
      }
    })
  }
}